import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "inline-block mr-3 text-sm font-semibold" }
const _hoisted_3 = { class: "w-full flex-grow" }
const _hoisted_4 = {
  key: 0,
  class: "flex mt-6"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-1 h-full mr-3 bg-primary-500 rounded" })
], -1)
const _hoisted_6 = { class: "text-gray-900 font-semibold" }
const _hoisted_7 = { class: "text-gray-600" }

import BaseSelectCheckbox from '@/lib/components/Select/BaseSelectCheckbox.vue';
import { TagFilter, TagGroupFilter } from '@/models';
import { ref, computed, Ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { NON_ASSIGNED } from '@/constants/tags';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  props: {
    tagGroups: null,
    preselectedTagGroups: null
  },
  emits: ["update:filteredTags"],
  setup(__props: any, { emit }: { emit: ({(
    e: 'update:filteredTags',
    value: { [key: string]: Array<TagFilter> }
  ): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tagGroups: Array<TagGroupFilter>,
  preselectedTagGroups: Array<TagGroupFilter>
}

const { t } = useI18n();
const filterCheckboxes = ref([]);
const selectedTags: Ref<Map<string, Array<TagFilter>>> = ref(new Map());





onMounted(() => {
  preselectTags();
});

const preselectTags = (): void => {
  if (!props.preselectedTagGroups) {
    return;
  }
  props.preselectedTagGroups.forEach((group: TagGroupFilter) => {
    selectedTags.value.set(group.name, group.tags);
  });
};

const preselectTagsModel = computed<Array<string>>(() => {
  let preselectTagsModel: Array<string> = [];
  selectedTags.value.forEach((tags: Array<TagFilter>) => {
    preselectTagsModel = [...preselectTagsModel, ...tags.map((tag: TagFilter) => tag.id)];
  });
  return preselectTagsModel;
});

const pushNonAssigned = (tags: Array<TagFilter>) => [
  ...tags.filter((tag) => tag.label !== NON_ASSIGNED),
  ...tags.filter((tag) => tag.label === NON_ASSIGNED)
];

const mapTagsToDisplayString = (tags: Array<TagFilter>): string => {
  const strList: Array<string> = tags.map((tag: TagFilter) => tag.label);
  strList.sort();
  return `${strList.join(', ')}; `;
};

const displaySelectedTags = computed<Map<string, string>>(() => {
  const displaySelectedTags: Map<string, string> = new Map();
  selectedTags.value.forEach((tags: Array<TagFilter>, groupName: string) => {
    displaySelectedTags.set(groupName, mapTagsToDisplayString(selectedTags.value.get(groupName)));
  });
  return displaySelectedTags;
});


const updateSelectedTags = (value: Ref<Array<TagFilter>>, groupName: string) => {
  if (value.length === 0) {
    selectedTags.value.delete(groupName);
  } else {
    selectedTags.value.set(groupName, [...value]);
  }
  emitUpdateEvent();
};

const emitUpdateEvent = (): void => {
  const eventData = Object.fromEntries(selectedTags.value);
  emit('update:filteredTags', eventData);
};

const unselectAll = () => {
  filterCheckboxes.value.forEach((el) => {
    el.clearAllSelections();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('platform.common.filters')), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tagGroups, (group, index) => {
        return (_openBlock(), _createBlock(BaseSelectCheckbox, {
          key: `filter-group-tags-${index}`,
          ref_for: true,
          ref: 
          (el) => {
            filterCheckboxes.value[index] = el;
          }
        ,
          "model-value": _unref(preselectTagsModel),
          options: pushNonAssigned(group.tags),
          placeholder: _ctx.$t(`custom.uhb.copd.${group.name}`),
          "is-filter": "",
          "data-dusk": `${group.name}-filter`,
          class: "mr-3 flex-grow-0",
          "onUpdate:listObject": ($event: any) => (updateSelectedTags($event, group.name))
        }, null, 8, ["model-value", "options", "placeholder", "data-dusk", "onUpdate:listObject"]))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        (selectedTags.value && selectedTags.value.size > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "h-12 px-3 text-gray-500 text-sm whitespace-no-wrap text-left",
              onClick: unselectAll
            }, _toDisplayString(_ctx.$t(`platform.common.clear-all`)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(displaySelectedTags) && _unref(displaySelectedTags).size > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displaySelectedTags), ([groupName, tagsDisplay]) => {
              return (_openBlock(), _createElementBlock("p", {
                key: groupName,
                class: "inline text-sm pr-2"
              }, [
                _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.$t(`custom.uhb.copd.${groupName}`)) + ": ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(tagsDisplay), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})